export const getV2Tasks = state => state.v2Tasks
export const getV2SelectedTask = (state) => getV2Tasks(state).selectedTask || {}
export const getV2IncompleteTasks = (state) => getV2Tasks(state).incompleteTasks || []
export const getV2CompleteTasks = (state) => getV2Tasks(state).completeTasks || []
